export default "__VITE_ASSET__9d5979ab__"